<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>

      </CHeaderNavItem>

       <label class=" text-right ml-5 mt-2"> <b> {{satellite_name}} </b>  </label>

    </CHeaderNav>

    <CHeaderNav>
        <CRow>
        <CCol>
      <label class=" text-right mr-2 mt-3"> Hi,<b> {{ datas.data.username }} </b></label>
      <!-- <CRow>
        <CCol>
       <small class="mr-3"> {{"Welcome to Your"}} <b> {{"IFGF Portal"}} </b> </small>
        </CCol>
      </CRow> -->
        </CCol>
      </CRow>

<!--
       <p class="mr-3 mt-3"> {{"Welcome to Your"}} <b> {{"IFGF Portal"}} </b> </p> -->

      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="mt-2">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import login from '@/services/login'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
   data () {
    return {
      mode: '',
      datas:[],
      username:'',
      satellite_name:'No Satellite Church',
      name:'',

      }
  },
  mounted(){
    this.load()
  },
methods:{

    load(){
        login.getLogin()
        .then(res => {
            this.datas = res;
            if (this.datas.data.people.member) {
              this.satellite_name = this.datas.data.people.member.satellite_church ? this.datas.data.people.member.satellite_church.name : null;
            }

        }).catch ((err) => {
          this.logout();
        })
    },
    logout: function () {
      return new Promise((resolve, reject) => {
          localStorage.removeItem('token')
          resolve()
      }).then(() => {
          this.$store.state.token = localStorage.getItem('token')
          this.$router.push('/login')
      })
    },
  }
}
</script>
